<template>
    <VList v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
    </VList>
</template>

<script>
const ELEMENT_CLASS = 'sr-list';

export default {
    name: 'SrList',
    computed: {
        classList() {
            return [ELEMENT_CLASS];
        },
    },
};
</script>
